import { useQuery, useMutation, MutationFunction } from 'react-query';
import { productAvailabilityNotificationsClient } from '../client/product-availability-notifications';
import { IProductAvailabilityNotification } from '@/types';
import { API_ENDPOINTS } from '../client/api-endpoints';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { productAvailabilityNotificationsAtom } from './store';
import { useUser } from '../user';

interface IOptions {
  onSuccess?: MutationFunction;
}

export const useGetProductAvailabilityNotifications = () => {
  const { me } = useUser({ enabled: true });

  const [_, setProductAvailabilityNotifications] = useAtom(
    productAvailabilityNotificationsAtom,
  );
  const { data } = useQuery(
    [API_ENDPOINTS.PRODUCT_AVAILABILITY_NOTIFICATIONS, me?.email],
    () => productAvailabilityNotificationsClient.get(me?.email),
    { enabled: !!me?.email },
  );

  useEffect(() => {
    setProductAvailabilityNotifications(data ?? []);
  }, [data]);
};

export const useProductAvailabilityNotificationFilter = ({
  product_id,
}: {
  product_id?: number;
  enabled?: boolean;
}) => {
  const [productAvailabilityNotifications] = useAtom(
    productAvailabilityNotificationsAtom,
  );

  const isAvailable = !!productAvailabilityNotifications?.find(
    (item) => item.product_id === product_id,
  );
  return { isAvailable };
};

export const useCreateProductAvailabilityNotification = ({
  onSuccess,
}: IOptions = {}) => {
  return useMutation(
    (input: IProductAvailabilityNotification) =>
      productAvailabilityNotificationsClient.post(input),
    {
      onSuccess,
    },
  );
};

export const useUpdateProductAvailabilityNotification = ({
  onSuccess,
}: IOptions = {}) => {
  return useMutation(
    (input: IProductAvailabilityNotification) =>
      productAvailabilityNotificationsClient.update(input),
    {
      onSuccess,
    },
  );
};

export const useDeleteProductAvailabilityNotification = ({
  onSuccess,
}: IOptions = {}) => {
  return useMutation(
    (id: string) => productAvailabilityNotificationsClient.delete(id),
    {
      onSuccess,
    },
  );
};
